import React, { Component } from "react";
import axios from "axios";
import {
  withStyles,
  Grid,
  Box,
  Typography,
  TextField,
  InputLabel,
  Button,
  Card,
  CircularProgress,
} from "@material-ui/core";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import { URL } from "../../config/config";
import { connect } from "react-redux";
import { SearchRounded } from "@material-ui/icons";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      searchString: "",
      paymentData: [],
      paymentSearchString: "",
      isLoadingPayment: false,
      paymentSearchPerformed: false,
      projectId: "",
    };
  }

  handleSearchName = (event) => {
    this.setState({ searchString: event.target.value });
  };

  handlePaymentSearch = (event) => {
    this.setState({ paymentSearchString: event.target.value });
  };

  isEmail(input) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(input);
  }

  isWhatsAppBusinessNumberWithPlus(input) {
    const whatsappRegex = /^\+?[1-9]\d{7,14}$/;
    return whatsappRegex.test(input);
  }

  otpFetcher = () => {
    let filt = {};
    filt = this.isEmail(this.state.searchString)
      ? {
          email: this.state.searchString,
          contact: "",
        }
      : { contact: this.state.searchString, email: "" };

    axios
      .post(URL + "/superadmin/get-signup-otps", filt)
      .then((res) => {
        const temp = res.data.result.documents;
        this.setState({ data: temp });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  paymentFetcher = () => {
    this.setState({ isLoadingPayment: true, paymentSearchPerformed: true });

    axios
      .post(URL + "/superadmin/get-payment-details", {
        paymentId: this.state.paymentSearchString,
      })
      .then((res) => {
        const temp = res.data;
        this.setState({
          paymentData: temp,
          isLoadingPayment: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching payment data:", error);
        this.setState({
          paymentData: [],
          isLoadingPayment: false,
        });
      });
  };

  fetchClients = async () => {
    try {
      this.setState({ isLoading: true, err: null });
      let filter = {};
      if (this.state.projectId) {
        filter["$text"] = { $search: this.state.projectId };
      }
      const queryObj = {
        skip: 0,
        rowsPerPage: 100,
        search: "",
        allFilters: { ...filter },
      };

      const response = await axios.post(URL + "/superadmin/get-clients", {
        ...queryObj,
      });

      if (!response || !response.data) {
        throw new Error("Invalid response from server");
      }
      let { templates = [] } = response.data;
      templates = templates.filter((item) => item?.firstProjectId);
      if (templates.length > 0) {
        this.setState({
          clientData: templates,
          isProject: false,
        });
      } else if (this.isWhatsAppBusinessNumberWithPlus(this.state.projectId)) {
        this.fetchProjects();
      }
    } catch (error) {
      console.error("Fetch templates error:", error);
    }
    this.setState({
      isLoading: false,
    });
  };

  fetchProjects = async () => {
    try {
      this.setState({ isLoading: true, err: null });
      const queryObj = {
        skip: 0,
        rowsPerPage: 15,
        allFilters: {
          $text: {
            $search: this.state.projectId,
          },
        },
      };

      const response = await axios.post(URL + "/superadmin/get-assistants", {
        ...queryObj,
      });

      if (!response || !response.data) {
        throw new Error("Invalid response from server");
      }

      const { templates = [] } = response.data;

      this.setState((prevState) => ({
        clientData: templates,
        isProject: true,
      }));
    } catch (error) {
      console.error("Fetch templates error:", error);
    }
    this.setState({
      isLoading: false,
    });
  };

  render() {
    const { classes, match, agent, permissions } = this.props;
    const {
      data,
      paymentData,
      clientData,
      isLoadingPayment,
      paymentSearchPerformed,
    } = this.state;

    const dashboardPermission = permissions.find(
      (p) => p.label === "dashboard"
    );
    const otpSearchPermission =
      dashboardPermission?.actions?.includes("searchOTP");
    const paymentSearchPermission =
      dashboardPermission?.actions?.includes("searchPayment");
    const projectSearchPermission =
      dashboardPermission?.actions?.includes("searchProject");

    return (
      <div className={classes.root}>
        {/* Page name & description container */}
        <Grid
          container
          justify="center"
          alignItems="center"
          className={`${classes.pageTitleContainer} ${classes.fullWidth}`}
        >
          <Grid item xs>
            <Box pl={{ xs: 2, md: 3 }}>
              <Typography variant="h3">Dashboard</Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          {/* First Card - OTP Search */}
          <Grid item xs={12} md={6}>
            <Card className={classes.card}>
              <Grid
                container
                alignItems="center"
                className={classes.searchContainer}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  width="100%"
                  p={{ xs: 2, md: 3 }}
                  borderRadius="4px"
                  className={classes.searchBox}
                >
                  <InputLabel
                    htmlFor="search-otp"
                    className={classes.searchLabel}
                  >
                    Search OTP
                  </InputLabel>
                  <TextField
                    id="search-number"
                    placeholder="Enter contact or email"
                    color="primary"
                    variant="outlined"
                    size="small"
                    value={this.state.searchString}
                    className={classes.searchField}
                    onChange={this.handleSearchName}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={!this.state.searchString || !otpSearchPermission}
                    onClick={this.otpFetcher}
                    className={classes.searchButton}
                  >
                    Search
                  </Button>
                </Box>
              </Grid>
              <Grid>
                <TableContainer component={Paper} className={classes.table}>
                  <Table>
                    <TableHead>
                      <TableRow className={classes.tableHeader}>
                        <TableCell className={classes.headerCell}>
                          Name
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                          OTP
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                          Date
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                          Time
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data
                        ?.sort((a, b) => {
                          const dateComparison =
                            new Date(b.createdAt) - new Date(a.createdAt);
                          if (dateComparison !== 0) {
                            return dateComparison; // Sort by date in descending order
                          } else {
                            // If dates are equal, sort by time in descending order
                            return (
                              new Date(b.createdAt).getTime() -
                              new Date(a.createdAt).getTime()
                            );
                          }
                        })
                        .map((item) => (
                          <TableRow key={item._id} className={classes.tableRow}>
                            <TableCell className={classes.tableCell}>
                              {item.fullName}
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                              {item.otp}
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                              {new Date(item.createdAt).toLocaleDateString(
                                "en-GB"
                              )}
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                              {new Date(item.createdAt).toLocaleTimeString(
                                "en-GB"
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Card>
          </Grid>

          {/* Second Card - Payment Search */}
          <Grid item xs={12} md={6}>
            <Card className={classes.card}>
              <Grid
                container
                alignItems="center"
                className={classes.searchContainer}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  width="100%"
                  p={{ xs: 2, md: 3 }}
                  borderRadius="4px"
                  className={classes.searchBox}
                >
                  <InputLabel
                    htmlFor="search-payment"
                    className={classes.searchLabel}
                  >
                    Search Payment
                  </InputLabel>
                  <TextField
                    id="search-payment"
                    placeholder="Enter payment ID"
                    color="primary"
                    variant="outlined"
                    size="small"
                    value={this.state.paymentSearchString}
                    className={classes.searchField}
                    onChange={this.handlePaymentSearch}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={
                      !this.state.paymentSearchString ||
                      isLoadingPayment ||
                      !paymentSearchPermission
                    }
                    onClick={this.paymentFetcher}
                    className={classes.searchButton}
                  >
                    {isLoadingPayment ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Search"
                    )}
                  </Button>
                </Box>
              </Grid>
              <Grid>
                <TableContainer component={Paper} className={classes.table}>
                  <Table>
                    <TableHead>
                      <TableRow className={classes.tableHeader}>
                        <TableCell className={classes.headerCell}>
                          Payment ID
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                          Project ID
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                          Amount
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                          Date
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                          Invoice ID
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {isLoadingPayment ? (
                        <TableRow>
                          <TableCell
                            colSpan={5}
                            align="center"
                            className={classes.messageCell}
                          >
                            <CircularProgress size={40} />
                            <Typography
                              variant="body2"
                              style={{ marginTop: 10 }}
                            >
                              Loading payment data...
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : paymentSearchPerformed &&
                        (!paymentData || paymentData.length === 0) ? (
                        <TableRow>
                          <TableCell
                            colSpan={5}
                            align="center"
                            className={classes.messageCell}
                          >
                            <Typography variant="body1" color="textSecondary">
                              No payment data found for this ID
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : (
                        paymentData
                          ?.sort((a, b) => {
                            const dateComparison =
                              new Date(b.createdAt) - new Date(a.createdAt);
                            if (dateComparison !== 0) {
                              return dateComparison;
                            } else {
                              return (
                                new Date(b.createdAt).getTime() -
                                new Date(a.createdAt).getTime()
                              );
                            }
                          })
                          .map((item) => (
                            <TableRow
                              key={item._id}
                              className={classes.tableRow}
                            >
                              <TableCell className={classes.tableCell}>
                                {item?.body?.payload?.payment?.entity?.id || ""}
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                {item.assistantId || ""}
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                {item?.amount ||
                                  item?.body?.payload?.payment?.entity?.amount /
                                    100 ||
                                  ""}
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                {new Date(item.createdAt).toLocaleDateString(
                                  "en-GB"
                                )}
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                {item.invoiceId}
                              </TableCell>
                            </TableRow>
                          ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Card>
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          {/* First Card - OTP Search */}
          <Grid item xs={12} md={12}>
            <Card className={classes.card} style={{ maxHeight: "650px" }}>
              <Grid
                container
                alignItems="center"
                className={classes.searchContainer}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  width="100%"
                  p={{ xs: 2, md: 3 }}
                  borderRadius="4px"
                  className={classes.searchBox}
                >
                  <InputLabel
                    htmlFor="search-otp"
                    className={classes.searchLabel}
                  >
                    Search Project
                    <h5 style={{ margin: "8px 0px" }}>
                      Click on the table row to redirect on the project detailed
                      view
                    </h5>
                  </InputLabel>
                  <TextField
                    id="search-number"
                    placeholder="Enter project Id or contact number"
                    color="primary"
                    variant="outlined"
                    size="small"
                    value={this.state.projectId}
                    disabled={this.state.isLoading}
                    className={classes.searchField}
                    onChange={(e) => {
                      this.setState({
                        projectId: e.target.value,
                      });
                    }}
                  />
                  {this.state.projectId && (
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={
                        !this.state.projectId ||
                        this.state.isLoading ||
                        !projectSearchPermission
                      }
                      onClick={() => {
                        const objectIdRegex = /^[a-f\d]{24}$/i;

                        if (objectIdRegex.test(this.state.projectId)) {
                          window.open(`/crm/${this.state.projectId}`, "_blank");
                          this.setState({
                            projectId: "",
                            isProject: false,
                            clientData: [],
                          });
                        } else if (this.state.projectId.length > 8) {
                          this.fetchClients();
                        } else {
                          return;
                        }
                      }}
                      className={classes.searchButton}
                      endIcon={
                        this.state.isLoading ? (
                          <CircularProgress size={12} />
                        ) : (
                          <SearchRounded size={12} />
                        )
                      }
                    >
                      Search
                    </Button>
                  )}
                </Box>
              </Grid>
              <Grid style={{ maxHeight: "500px", overflowY: "scroll" }}>
                <TableContainer component={Paper} className={classes.table}>
                  <Table>
                    <TableHead>
                      <TableRow className={classes.tableHeader}>
                        <TableCell className={classes.headerCell}>
                          {this.state.isProject ? "Project Name" : "Name"}
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                          {this.state.isProject ? "Business ID" : "Email"}
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                          {this.state.isProject ? "API Number" : "Contact"}
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                          {this.state.isProject
                            ? "Project ID"
                            : "First Project ID"}
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                          Created At
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {clientData
                        ?.sort((a, b) => {
                          const dateComparison =
                            new Date(b.createdAt) - new Date(a.createdAt);
                          if (dateComparison !== 0) {
                            return dateComparison; // Sort by date in descending order
                          } else {
                            // If dates are equal, sort by time in descending order
                            return (
                              new Date(b.createdAt).getTime() -
                              new Date(a.createdAt).getTime()
                            );
                          }
                        })
                        .filter(
                          (item) =>
                            item?.firstProjectId || item?.isWhatsappVerified
                        )
                        .map((item) => (
                          <TableRow
                            key={item._id}
                            className={classes.tableRow}
                            onClick={() => {
                              if (this.state.isProject) {
                                window.open(`/crm/${item._id}`, "_blank");
                              } else {
                                window.open(
                                  `/crm/${item.firstProjectId}`,
                                  "_blank"
                                );
                              }
                            }}
                          >
                            <TableCell className={classes.tableCell}>
                              {item.name || item.assistantName}
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                              {item.email || item.clientId}
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                              {item.contact || item.whatsappNumber}
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                              {item.firstProjectId || item._id}
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                              {new Date(item.createdAt).toLocaleString()}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Card>
          </Grid>
        </Grid>

        <Box my={3} />
        {/* Layout */}
        <Grid container justify="center">
          <Grid item xs={12} md={10} lg={8}></Grid>
        </Grid>
        <Box my={8} />
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    width: "100%",
    height: "100%",
    background: "rgb(247,247,247)",
    boxSizing: "border-box",
    overflowX: "hidden",
    position: "relative",
    padding: theme.spacing(2),
  },
  pageTitleContainer: {
    position: "sticky",
    zIndex: 100,
    top: 0,
    height: 64,
    boxSizing: "border-box",
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
      // paddingTop: "40px",
    },
    [theme.breakpoints.down("sm")]: {
      // paddingTop: "20px",
    },
  },
  card: {
    maxHeight: "400px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
    overflow: "auto",
    marginTop: theme.spacing(1),
    borderRadius: "12px",
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.12)",
    },
  },
  searchContainer: {
    display: "flex",
    justifyContent: "flex-start",
    padding: theme.spacing(2),
    borderBottom: "1px solid #f0f0f0",
  },
  searchBox: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  searchLabel: {
    marginRight: theme.spacing(2),
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  searchField: {
    backgroundColor: "#f5f5f5",
    width: "280px",
    marginRight: theme.spacing(2),
    "& .MuiOutlinedInput-root": {
      borderRadius: 4,
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  searchButton: {
    minWidth: "100px",
    height: "36px",
  },
  table: {
    minWidth: 450,
  },
  tableHeader: {
    backgroundColor: "#f7f7f7",
  },
  headerCell: {
    fontWeight: "bold",
    fontSize: "0.9em",
    color: theme.palette.text.secondary,
    padding: theme.spacing(1.5),
  },
  tableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#fafafa",
    },
    "&:hover": {
      backgroundColor: "#f0f7ff",
    },
  },
  tableCell: {
    fontSize: "0.9em",
    padding: theme.spacing(1.5),
  },
  messageCell: {
    padding: theme.spacing(4),
    textAlign: "center",
  },
  fullWidth: {
    width: "100%",
    background: "white",
  },
  primaryBackground: {
    background: "#EBF5F3",
  },
});

const connectedDashboard = connect((state) => ({
  agent: state.login.user,
  permissions: state.login.permissions,
}))(Dashboard);

export default withStyles(styles)(connectedDashboard);
